import React from "react";

import { useFlags } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { ClientId } from "@fartherfinance/frontend/api/Types";

import RedirectWithFlag from "@src/config/routing/RedirectWithFlag";
import { InvestmentsPath } from "@src/config/routing/RouterPaths";
import { initialTransitionProposalFlowState } from "@src/multiCustodian/components/TransitionProposals/constants";
import { TransitionProposalFlowStateData } from "@src/multiCustodian/components/TransitionProposals/types";
import FlowContainerContext from "@src/sharedComponents/FlowContainer/reducer/Context";
import { useProgressReducer } from "@src/sharedComponents/FlowContainer/reducer/reducer";
import { State } from "@src/store";

import TransitionProposalFlowContainer from "./TransitionProposalFlowContainer";

const TransitionProposalFlowProvider: React.FC = () => {
  const { clientId } = useParams<{
    clientId: ClientId;
  }>();

  const { enableTransitionProposals } = useFlags();

  const [state, dispatch] = useProgressReducer<TransitionProposalFlowStateData>(
    initialTransitionProposalFlowState
  );

  const { isAdvisor } = useSelector(
    (state: State) => state.main_Reducer.user ?? false
  );

  const enableProposalFlow = enableTransitionProposals && isAdvisor;

  return (
    <FlowContainerContext.Provider value={{ state, dispatch }}>
      <RedirectWithFlag
        flag={enableProposalFlow}
        redirectPath={`/Client/${clientId}/${InvestmentsPath}`}
      >
        <TransitionProposalFlowContainer />
      </RedirectWithFlag>
    </FlowContainerContext.Provider>
  );
};

export default TransitionProposalFlowProvider;
